<!--
/*******************************************************************************
*@ 컴포넌트명   : PersonalInfo2.vue
*@ 컴포넌트설명 : 고객정보조회/변경 - 확인 [개인]
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section class="corporation">
    <nos-component ref="NOS_COMPONENT" :component="this.NOS_INSTANCE.components" />
    <div class="scroll">
      <contents-header :bg-type="true" title="MPRS-01-01-07-01" description="MPRS-01-01-07-02" />
      <article class="contents">
        <div class="form">
          <!-- 고객명 -->
          <div class="form-row">
            <input-text
              ref="ovsesCustOcntryName"
              id="ovsesCustOcntryName"
              :value="RBF0409E40_data.ovsesCustOcntryName"
              disabled
              label-i18n="MPRS-01-01-07-03"
            />
          </div>
          <!-- 자택 전화번호 -->
          <div class="form-row">
            <input-text
              ref="owhusTelno"
              id="owhusTelno"
              :value="RBF0409E40_data.owhusTelno"
              disabled
              label-i18n="MPRS-01-01-07-04"
            />
          </div>
          <!-- 휴대폰 전화번호 -->
          <div class="form-row">
            <input-text
              ref="cphnNo"
              id="cphnNo"
              :value="RBF0409E40_data.cphnNo"
              disabled
              label-i18n="MPRS-01-01-07-05"
            />
          </div>
          <!-- 이메일 주소 -->
          <div class="form-row">
            <input-text
              ref="emad1"
              id="emad1"
              :value="RBF0409E40_data.emad1"
              disabled
              label-i18n="MPRS-01-01-07-06"
            />
          </div>
          <!-- 자택 주소 -->
          <div class="form-row">
            <div class="item-tit">{{ /*자택 주소*/ $t("MPRS-01-01-07-07") }}</div>
            <div class="item-desc">
              <input-text
                v-if="RBF0409E40_data.owhusNmad"
                ref="owhusNmad"
                id="owhusNmad"
                :value="RBF0409E40_data.owhusNmad"
                disabled
              />
              <input-text
                ref="owhusAddr1"
                id="owhusAddr1"
                :value="RBF0409E40_data.owhusAddr1"
                disabled
              />
              <input-text
                v-if="RBF0409E40_data.owhusAddr2"
                ref="owhusAddr2"
                id="owhusAddr2"
                :value="RBF0409E40_data.owhusAddr2"
                disabled
              />
              <input-text
                v-if="RBF0409E40_data.owhusAddr3"
                ref="owhusAddr3"
                id="owhusAddr3"
                :value="RBF0409E40_data.owhusAddr3"
                disabled
              />
            </div>
          </div>
          <!-- 회사 주소 -->
          <div class="form-row">
            <div class="item-tit">{{ /* 주소*/ $t("MPRS-01-01-07-08") }}</div>
            <div class="item-desc">
              <input-text
                v-if="RBF0409E40_data.coNmad"
                ref="coNmad"
                id="coNmad"
                :value="RBF0409E40_data.coNmad"
                disabled
              />
              <input-text ref="coAddr1" id="coAddr1" :value="RBF0409E40_data.coAddr1" disabled />
              <input-text
                v-if="RBF0409E40_data.coAddr2"
                ref="coAddr2"
                id="coAddr2"
                :value="RBF0409E40_data.coAddr2"
                disabled
              />
              <input-text
                v-if="RBF0409E40_data.coAddr3"
                ref="coAddr3"
                id="coAddr3"
                :value="RBF0409E40_data.coAddr3"
                disabled
              />
            </div>
          </div>
          <!-- 우편물 수신 -->
          <div class="form-row">
            <input-text
              ref="postSendAreaDstcd"
              id="postSendAreaDstcd"
              :value="$te(RBF0409E40_data.postSendAreaDstcd+'_우편발송지구분코드')?$t(RBF0409E40_data.postSendAreaDstcd+'_우편발송지구분코드'):''"
              disabled
              label-i18n="MPRS-01-01-07-09"
            />
          </div>
          <!-- 거래 Statement 우편발송 여부 -->
          <div v-if="siteCode===$config.SITECODE_OGAUC" class="form-row">
            <input-text
              ref="postSendYn"
              id="postSendYn"
              :value="$te(RBF0409E40_data.postSendYn+'_우편발송여부')?$t(RBF0409E40_data.postSendYn+'_우편발송여부'):''"
              disabled
              label-i18n="MPRS-01-01-07-11"
            />
            <div
              v-if="siteCode===$config.SITECODE_OGAUC"
              class="info info-etc"
            >※ {{ /*조회 > 거래내역조회 > Statement조회 에서 조회 후 인쇄할 수 있습니다.*/ $t("MPRS-01-01-07-13") }}</div>
          </div>
        </div>

        <div class="notice notice-box--type">
          <div class="notice-tit">
            <p class="bullet">{{ /*유의사항*/ $t("MPRS-01-01-07-14") }}</p>
          </div>
          <div class="notice-cont">
            <ul class="ulist bar">
              <li>- {{ /*잘못된 정보로 인한 우편물 반송에 대한 책임은 당사자가 지지 않습니다.*/ $t("MPRS-01-01-07-15") }}</li>
            </ul>
          </div>
        </div>
      </article>
    </div>
    <div class="btn-area--full fixed">
      <button class="btn md normal" @click="goNextStep">{{ /*확인*/ $t("MCOM-0000003") }}</button>
    </div>
    <approval-line ref="otp" :NOS_INSTANCE_REFERANCE="NOS_INSTANCE" @authOpen="confirmOtp" />
  </section>
</template>
<script>
import ApprovalLine from "@/components/page/common/ApprovalLine";
import NOSComponent from "@/components/page/pluginFree/NOSComponent";
import NOSController from "@/components/page/pluginFree/NOSController";
import Common from "@/components/basic/Common";
import { mapFields } from "vuex-map-fields";

export default {
  extends: Common,
  components: {
    "nos-component": NOSComponent,
    ApprovalLine,
  },
  computed: {
    ...mapFields("admin/personalInfo", ["RBF0409E40_data"]),
  },
  mounted() {
    this.NOS_INSTANCE.init();
  },
  data() {
    return {
      NOS_INSTANCE: new NOSController(this, {
        componentid: "NOS_COMPONENT",
        kpd: true,
      }),
    };
  },
  methods: {
    RBF0509F50Call() {
      let params = {
        inquryOwhusTelno: this.RBF0409E40_data.owhusTelno,
        inquryCphnNo: this.RBF0409E40_data.cphnNo,
        inquryEmad1: this.RBF0409E40_data.emad1,
        inquryOwhusNmad: this.RBF0409E40_data.owhusNmad,
        inquryOwhusAddr1: this.RBF0409E40_data.owhusAddr1,
        inquryOwhusAddr2: this.RBF0409E40_data.owhusAddr2,
        inquryOwhusAddr3: this.RBF0409E40_data.owhusAddr3,
        inquryCoNmad: this.RBF0409E40_data.coNmad,
        inquryCoAddr1: this.RBF0409E40_data.coAddr1,
        inquryCoAddr2: this.RBF0409E40_data.coAddr2,
        inquryCoAddr3: this.RBF0409E40_data.coAddr3,
        inquryPostSendAreaDstcd: this.RBF0409E40_data.postSendAreaDstcd,
        inquryPostSendYn: this.RBF0409E40_data.postSendYn,
        // inquryLginPtimOtpUseYn: this.RBF0409E40_data.lginPtimOtpUseYn,
        _nprotected: this.NOS_INSTANCE.toJSON(),

        commAuth: { biz: this.$config.AUTH_01, bizParam: {} },
      };

      this.$post("/customer/cust/CustInfoUpt3", params, this.RBF0509F50Suc);
    },
    RBF0509F50Suc() {
      this.$router.push({ name: "perInfoStep3" });
    },
    goNextStep() {
      this.$refs.otp.open();
    },
    confirmOtp() {
      this.RBF0509F50Call();
    },
  },
};
</script>